import AdminPackages from './AdminPackages';
import { ADMIN_COLORS } from '../constants/bookingConst';
import '../css/AdminEvents.css';

// Shared jassen light palette (constants/bookingConst.js)
const COLORS = ADMIN_COLORS;

// Admin -> Events and Packages.
//
// This screen used to be an event-POSTER manager: upload an image, store it
// base64 in the /events Firebase node, list them, delete them. It was removed
// because nothing ever rendered those posters — no guest screen and no admin
// screen read /events, so every upload was write-only storage. See
// AdminPackages.jsx for what the screen does now.
//
// Kept as a thin wrapper rather than pointing AdminPage straight at
// AdminPackages: it owns the screen's heading and the .admin-events layout
// (padding, max-width, the mobile type scale in AdminEvents.css), which are
// screen-level concerns rather than the packages editor's.
function AdminEvents() {
  return (
    <div className="admin-events" style={{ color: COLORS.textSecondary }}>
      <h2 className="section-title">🎉 Events and Packages</h2>
      <p style={{ marginBottom: '1.5rem', opacity: 0.7 }}>
        Bookable packages your club offers — whole-court event hire sold as a block of hours.
      </p>

      <div
        className="packages-section"
        style={{
          background: COLORS.cardSolid,
          padding: '1.5rem',
          borderRadius: '12px',
          border: `1px solid ${COLORS.line}`,
        }}
      >
        <AdminPackages />
      </div>
    </div>
  );
}

export default AdminEvents;
